var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100%" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("common.documents")))]),
      _c(
        "w-scroll-view",
        {
          style: { paddingTop: "0" },
          attrs: { tag: "w-card-content", grow: "" },
        },
        [
          _vm.documents.length === 0
            ? _c("div", { style: { paddingTop: "15px" } }, [
                _vm._v(_vm._s(_vm.$ct("no-documents"))),
              ])
            : _c(
                "w-list",
                _vm._l(_vm.documents, function (entry) {
                  return _c(
                    "w-list-item",
                    { key: entry.doc.ID },
                    [
                      _c(
                        "w-list-item-icon",
                        [_c("w-fa", { attrs: { icon: ["far", "file"] } })],
                        1
                      ),
                      _c("w-list-item-text", [
                        _vm._v(" " + _vm._s(entry.doc.getName()) + " "),
                        _c("div", { staticClass: "meta" }, [
                          _vm._v(_vm._s(entry.timestamp)),
                        ]),
                      ]),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("common.preview"),
                                  expression: "$ct('common.preview')",
                                },
                              ],
                              attrs: { disabled: !entry.doc.canPreview() },
                              on: {
                                click: function ($event) {
                                  return _vm.preview(entry.doc)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "eye" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("common.download"),
                                  expression: "$ct('common.download')",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.download(entry.doc)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "download" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("common.delete"),
                                  expression: "$ct('common.delete')",
                                },
                              ],
                              staticClass: "danger",
                              on: {
                                click: function ($event) {
                                  return _vm.remove(entry)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "trash" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }